import React, { useRef, useState, useEffect, useContext } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import send from "../../Assets/Images/send.png";
import axios from "axios";
import {
  showToast,
  WEBSERVICE,
  checkCurrencyPairAccreditedStatus,
} from "../../CoreDataService";
import { useNavigate } from "react-router-dom";
import InfoPopUp from "../../Common/InfoPopUp";
import { DataContext } from ".";
import TelegramIcon from "@mui/icons-material/Telegram";
import InfoIcon from "@mui/icons-material/Info";
import AccreditationVerificationPopup from "../Accredited-Kyc/AccreditationVerificationPopup";
import TermsAgreementPopup from "../Accredited-Kyc/TermsAgreementPopup";
import { showErrorDialog } from "../../CoreDataService";

const title = "Market";
const description = `Users can Buy and Sell in the current market price. Enter "Buying
              Amount" and click on BUY to place a BUY Market order. Enter
              "Selling Amount" and click on SELL to place a SELL Market order.`;

const BuyAndSellMarket = ({
  selectedBuyingAssetBalance,
  selectedSellingAssetBalance,
  percentageValue,
  getUserTransaction,
  minBuySellAmount,
}) => {
  const { currencycode, basecurrency, setUpdateOrder } =
    useContext(DataContext);
  console.log("minBuySellAmount", minBuySellAmount);
  const navigate = useNavigate();
  const theme = localStorage.getItem("theme");
  const tradep = localStorage.getItem("priceprc") || 6;
  const [show, setShow] = useState(false);
  const [progress, setProgress] = useState(0);
  const progressBarRef = useRef(null);
  const [sliderValue, setSliderValue] = useState(0);
  const sliderRef = useRef(null);
  const steps = [0, 25, 50, 75, 100];
  const [isLoading, setIsLoading] = useState(false);
  const [onlyBuyAmount, setOnlyBuyAmount] = useState("");
  const [onlyBuyPrice, setOnlyBuyPrice] = useState("");
  const [onlyBuyTotalPrice, setOnlyBuyTotalPrice] = useState();
  const [isDirty, setIsDirty] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);

  const [onlySellAmount, setOnlySellAmount] = useState("");
  const [onlySellPrice, setOnlySellPrice] = useState("");
  const [buyDisabled, setBuyDisabled] = useState(true);
  const [sellDisabled, setSellDisabled] = useState(true);

  const [error, setError] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const [onlySellTotalPrice, setOnlySellTotalPrice] = useState();
  const [sellError, setSellError] = useState(false);
  const [marketSellError, setMarketSellError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showAccreditedPopup, setShowAccreditedPopup] = useState(false);
  const [showTermsPopup, setShowTermsPopup] = useState(false);
  const [termsLinks, setTermsLinks] = useState([]);
  const [pendingProceed, setPendingProceed] = useState(null);
  const [pendingTxnType, setPendingTxnType] = useState(null);

  const handleSliderInteraction = (event) => {
    if (!sliderRef.current) return;

    const { left, width } = sliderRef.current.getBoundingClientRect();
    const clickX = event.clientX - left;
    const rawProgress = (clickX / width) * 100;

    // Find the closest step value
    const closestStep = steps.reduce((prev, curr) =>
      Math.abs(curr - rawProgress) < Math.abs(prev - rawProgress) ? curr : prev
    );

    setSliderValue(closestStep);
    let calculatedSellAmount = selectedBuyingAssetBalance * (closestStep / 100);
    setOnlySellAmount(parseFloat(calculatedSellAmount).toFixed(tradep));
    getSellValSlider(calculatedSellAmount);
    validateMarketSell();
  };
  const handleProgressChange = (event) => {
    if (!progressBarRef.current) return;

    const { left, width } = progressBarRef.current.getBoundingClientRect();
    const clickX = event.clientX - left;
    const rawProgress = (clickX / width) * 100;

    // Find the closest step value
    const closestStep = steps.reduce((prev, curr) =>
      Math.abs(curr - rawProgress) < Math.abs(prev - rawProgress) ? curr : prev
    );

    setProgress(closestStep);
    fetchMarketData(closestStep);
  };
  const handleClose = () => setShow(false);
  const resetSliderBuy = () => {
    setProgress(0);
  };
  const resetSliderSell = () => {
    setSliderValue(0);
  };

  const handleKeyUp = (event) => {
    setIsDirty(true);
    getBuyVal(event);
    resetSliderBuy();
    validatemarketbuy();
  };

  const handleChange = (event) => {
    const value = event.target.value;
    const regex = new RegExp(`^\\d*\\.?\\d{0,${tradep}}$`);
    if (regex.test(value)) {
      setOnlyBuyAmount(value);
    }

    setIsInvalid(value === "" || isNaN(value)); // Example validation
  };

  const getBuyVal = (event) => {
    const val = event.target.value;
    setOnlyBuyAmount(val);
    // document.getElementById("customRange3")?.classList.remove("changeBackgroundSlider");

    if (val === "" || isNaN(val) || parseFloat(val) < 0) {
      showToast("warning", "Amount cannot be negative or blank");
      setOnlyBuyAmount("");
      setOnlyBuyPrice(0);
      setOnlyBuyTotalPrice(0);
      // document.getElementById("mbuy").disabled = true;
      return;
    }
    if (val < minBuySellAmount?.minBuyQty) {
      showToast(
        "warning",
        `The amount must be at least ${minBuySellAmount?.minBuyQty}`
      );
      setOnlyBuyPrice(0);
      setOnlyBuyTotalPrice(0);
      // document.getElementById("mbuy").disabled = true;
      return;
    }

    axios
      .get(
        `https://stream.paybito.com/SocketStream/api/marketPrice?symbol=${currencycode?.toUpperCase()}${basecurrency?.toUpperCase()}&side=BID&amount=${val}`
      )
      .then((response) => {
        const result = response.data;

        if (result.statuscode !== 0 && result.price && !isNaN(result.price)) {
          const price = parseFloat(result.price);
          const amount = parseFloat(val);

          if (isNaN(price) || isNaN(amount)) {
            setOnlyBuyPrice(0);
            setOnlyBuyTotalPrice(0);
            // document.getElementById("mbuy").disabled = true;
            return;
          }

          const totalPrice = (price * amount).toFixed(tradep);

          setOnlyBuyPrice(price.toFixed(tradep));
          setOnlyBuyTotalPrice(totalPrice);
          // document.getElementById("mbuy").disabled = parseFloat(totalPrice) < 0.001;
        } else {
          setOnlyBuyPrice(0);
          setOnlyBuyTotalPrice(0);
          // document.getElementById("mbuy").disabled = true;
        }
      })
      .catch((error) => {
        console.error("Error fetching trade data", error);
        setOnlyBuyPrice(0);
        setOnlyBuyTotalPrice(0);
        // document.getElementById("mbuy").disabled = true;
      });
  };

  const validatemarketbuy = () => {
    if (onlyBuyAmount <= 0.0001) {
      // document.getElementById("marketbuy").disabled = true;
    } else {
      // document.getElementById("marketbuy").disabled = false;
    }
  };

  const handleAmountFromTotalPrice = async (e, type) => {
    let inputValue = e.target.value;

    if (type === "buy") {
      setOnlyBuyTotalPrice(inputValue);
    } else {
      setOnlySellTotalPrice(inputValue);
    }

    let balance = parseFloat(selectedSellingAssetBalance);

    if (!inputValue || parseFloat(inputValue) > balance) {
      // setOnlyBuyAmount("");
      // setOnlySellAmount("");
      // setOnlyBuyPrice("");
      // setOnlySellPrice("");
      // setBuyDisabled(true);
      // setSellDisabled(true);
      showToast("warning", "Total Price is exceeding your current balance");
      // return;
    }

    try {
      const response = await fetch(
        `https://stream.paybito.com/SocketStream/api/depth?symbol=${currencycode}${basecurrency}&limit=1`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      const data = await response.json();

      if (type === "buy") {
        const price = parseFloat(data.ask[0].price).toFixed(tradep);
        const amount = (
          parseFloat(inputValue) / parseFloat(data.ask[0].price)
        ).toFixed(tradep);
        setOnlyBuyPrice(price);
        setOnlyBuyAmount(amount);
        // setOnlyBuyTotalPrice(inputValue);
        // setBuyDisabled(parseFloat(amount) <= 0.0001);
        resetSliderBuy();
      } else {
        const price = parseFloat(data.bid[0].price).toFixed(tradep);
        const amount = (
          parseFloat(inputValue) / parseFloat(data.bid[0].price)
        ).toFixed(tradep);
        setOnlySellPrice(price);
        setOnlySellAmount(amount);
        // setOnlySellTotalPrice(inputValue);
        // setSellDisabled(parseFloat(amount) <= 0.0001);
        resetSliderSell();
      }
    } catch (error) {
      console.error("Error fetching market data:", error);
    }
  };

  const fetchMarketData = async (sliderValue) => {
    try {
      const buyingCrypto = currencycode;
      const sellingCrypto = basecurrency;
      const token = localStorage.getItem("access_token");

      const response = await axios.get(
        `https://stream.paybito.com/SocketStream/api/depth?symbol=${buyingCrypto}${sellingCrypto}&limit=1`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${token}`,
          },
        }
      );

      const askPrice = parseFloat(response.data.ask[0].price);
      const calculatedAmount = (
        (selectedSellingAssetBalance * (sliderValue / 100) -
          selectedSellingAssetBalance * (sliderValue / 100) * percentageValue) /
        askPrice
      ).toFixed(tradep);

      // setOnlyBuyAmount(calculatedAmount);
      console.log("Calculated Buy Amount:", calculatedAmount);
      getBuyValSlider(calculatedAmount);
      validatemarketbuy();
    } catch (error) {
      console.error("Error fetching market data:", error);
    }
  };

  const getBuyValSlider = async (val) => {
    if (val < 0 || val === "") {
      if (val === 0) {
        setOnlyBuyPrice(0);
        setOnlyBuyTotalPrice(0);
      }
      setError("Amount cannot be negative or blank");
      setOnlyBuyAmount("");
      return;
    }

    setOnlyBuyAmount(parseFloat(val).toFixed(tradep));
    try {
      const response = await axios.get(
        `https://stream.paybito.com/SocketStream/api/marketPrice?symbol=${currencycode.toUpperCase()}${basecurrency.toUpperCase()}&side=BID&amount=${val}`
      );
      const result = response.data;

      if (result.statuscode !== "0") {
        const price = parseFloat(result.price).toFixed(tradep);
        const totalPrice = (parseFloat(result.price) * parseFloat(val)).toFixed(
          tradep
        );
        setOnlyBuyPrice(price);
        console.log("totalPrice", totalPrice, price);
        setOnlyBuyTotalPrice(totalPrice);

        // if (totalPrice < 0.001) {
        //   setError("Total price too low");
        //   setIsDisabled(true);
        // } else {
        //   setError("");
        //   setIsDisabled(false);
        // }
      } else {
        setOnlyBuyPrice(0);
        setOnlyBuyTotalPrice(0);
        setError("Error fetching price");
        setIsDisabled(true);
      }
    } catch (error) {
      setError("Network error, please try again");
    }
  };

  const getAssetCode = (counter, base) => {
    try {
      const assets = JSON.parse(localStorage.getItem("spot_assets")) || [];

      const asset = assets.find(
        (item) =>
          counter.toUpperCase() === item.currencyCode.toUpperCase() &&
          base.toUpperCase() === item.baseCurrency.toUpperCase()
      );

      return asset ? asset.assetCode : "";
    } catch (error) {
      console.error("Error parsing spot_assets:", error);
      return "";
    }
  };

  /* Get base and counter ID of a pair */
  const getAssetId = (counter, base) => {
    try {
      const assets = JSON.parse(localStorage.getItem("spot_assets")) || [];

      const asset = assets.find(
        (item) =>
          counter.toUpperCase() === item.currencyCode.toUpperCase() &&
          base.toUpperCase() === item.baseCurrency.toUpperCase()
      );

      return asset
        ? { baseCurrencyId: asset.baseCurrencyId, currencyId: asset.currencyId }
        : {};
    } catch (error) {
      console.error("Error parsing spot_assets:", error);
      return {};
    }
  };

  const marketBuy = async () => {
    setIsLoading(true);
    console.log("calling market");

    const accreditationResult = await checkCurrencyPairAccreditedStatus(
      localStorage.getItem("userId"),
      currencycode?.toUpperCase(),
      basecurrency?.toUpperCase(),
      "BUY",
      onlyBuyAmount
    );

    if (!accreditationResult.accessAllowed) {
      setIsLoading(false);
      setShowAccreditedPopup(true);
      return;
    }

    const proceed = async () => {
      await doMarketBuy();
    };

    if (accreditationResult.requiresTermsAgreement) {
      setIsLoading(false);
      setTermsLinks(accreditationResult.links || []);
      setPendingProceed(() => proceed);
      setPendingTxnType(1);
      setShowTermsPopup(true);
      return;
    }

    await proceed();
  };

  const doMarketBuy = async () => {
    setIsLoading(true);

    let inputObj = {
      selling_asset_code: basecurrency?.toUpperCase(),
      buying_asset_code: currencycode?.toUpperCase(),
      amount: parseFloat(onlyBuyAmount),
      price: onlyBuyPrice,
      offerType: "M",
      txn_type: "1",
      uuid: localStorage.getItem("uuid"),
      assetCode: getAssetCode(currencycode, basecurrency),
      baseCurrencyId: getAssetId(currencycode, basecurrency)?.baseCurrencyId,
      currencyId: getAssetId(currencycode, basecurrency)?.currencyId,
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}userTrade/TradeCreateOffer`,
        JSON.stringify(inputObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      setIsLoading(false);
      const result = response.data;

      if (result.error.error_data !== 0) {
        if (result.error.error_data === 2) {
          showErrorDialog(result);
        } else {
          showToast("error", result.error.error_msg);
        }
      } else {
        reset();
        showToast("success", result.error.error_msg);
        getUserTransaction();
        setUpdateOrder((prev) => !prev);

        if (localStorage.getItem("tradeNavHist") === "open") {
          // data.renderDataForMyOfferSpot();
        } else if (localStorage.getItem("tradeNavHist") === "stop") {
          // data.renderDataForStopLimitSpot('buy');
        } else {
          localStorage.setItem("isTimeToRenderSpotMyTrade", "true");
        }
      }
    } catch (error) {
      console.error("Trade creation failed", error);
      setIsLoading(false);
      showToast("error", "Trade creation failed");
    }
  };

  const reset = () => {
    setOnlyBuyAmount("");
    setOnlyBuyPrice("");
    setProgress(0);
    setOnlyBuyTotalPrice("");
  };

  const getSellVal = async (event) => {
    let val = event.target.value;
    const regex = new RegExp(`^\\d*\\.?\\d{0,${tradep}}$`);
    if (regex.test(val)) {
      setOnlySellAmount(val);
    }

    resetSliderSell();

    if (val < 0 || val === "") {
      showToast("warning", "Amount cannot be negative or blank");
      setOnlySellAmount("");
      return;
    }

    if (val < minBuySellAmount?.minSellQty) {
      showToast(
        "warning",
        `The amount must be at least ${minBuySellAmount?.minSellQty}`
      );
      setOnlySellPrice(0);
      setOnlySellTotalPrice(0);
      // document.getElementById("mbuy").disabled = true;
      return;
    }

    try {
      const response = await axios.get(
        `https://stream.paybito.com/SocketStream/api/marketPrice?symbol=${currencycode?.toUpperCase()}${basecurrency?.toUpperCase()}&side=ASK&amount=${val}`
      );
      const result = response.data;

      if (result.statuscode !== 0) {
        const price = parseFloat(result.price).toFixed(tradep);
        const totalPrice = (parseFloat(result.price) * parseFloat(val)).toFixed(
          tradep
        );

        setOnlySellPrice(price);
        setOnlySellTotalPrice(totalPrice);
        // setSellError(totalPrice < 0.001);

        if (result?.message == "Order not found.") {
          showToast("error", "Order book depth reached. Order not found.");
          setOnlySellAmount("");
        }
      } else {
        // setOnlySellPrice(0);
        // setOnlySellTotalPrice(0);
        setSellError(true);
      }
    } catch (error) {
      console.error("Error fetching sell data", error);
    }
  };

  const validateMarketSell = () => {
    // if (parseFloat(onlySellAmount) <= 0.0001) {
    //   setMarketSellError(true);
    //   return true;
    // } else {
    //   setMarketSellError(false);
    //   return false;
    // }
  };

  const getSellValSlider = async (amount) => {
    if (amount < 0 || amount === "") {
      // if (amount === 0) {
      //   setOnlySellPrice(0);
      //   setOnlySellTotalPrice(0);
      // }
      showToast("warning", "Amount cannot be negative or blank");
      // setOnlySellAmount("");
      return;
    }

    try {
      const response = await fetch(
        `https://stream.paybito.com/SocketStream/api/marketPrice?symbol=${currencycode?.toUpperCase()}${basecurrency?.toUpperCase()}&side=ASK&amount=${amount}`
      );
      const result = await response.json();

      if (result.statuscode !== 0) {
        let price = parseFloat(result.price).toFixed(tradep);
        let totalPrice = (
          parseFloat(result.price) * parseFloat(amount)
        ).toFixed(tradep);
        setOnlySellPrice(price);
        setOnlySellTotalPrice(totalPrice);
        // showToast("error", result?.message)
      } else {
        setOnlySellPrice(0);
        setOnlySellTotalPrice(0);
      }
    } catch (error) {
      console.error("Error fetching trade data:", error);
    }
  };

  const marketSell = async () => {
    setLoading(true);

    const accreditationResult = await checkCurrencyPairAccreditedStatus(
      localStorage.getItem("userId"),
      currencycode?.toUpperCase(),
      basecurrency?.toUpperCase(),
      "SELL",
      onlySellAmount
    );

    if (!accreditationResult.accessAllowed) {
      setIsLoading(false);
      setLoading(false);
      setShowAccreditedPopup(true);
      return;
    }

    const proceed = async () => {
      await doMarketSell();
    };

    if (accreditationResult.requiresTermsAgreement) {
      setIsLoading(false);
      setLoading(false);
      setTermsLinks(accreditationResult.links || []);
      setPendingProceed(() => proceed);
      setPendingTxnType(2);
      setShowTermsPopup(true);
      return;
    }

    await proceed();
  };

  const doMarketSell = async () => {
    setLoading(true);

    const inputObj = {
      selling_asset_code: currencycode?.toUpperCase(),
      buying_asset_code: basecurrency?.toUpperCase(),
      amount: parseFloat(onlySellAmount),
      price: parseFloat(onlySellPrice),
      offerType: "M",
      txn_type: "2",
      assetCode: getAssetCode(currencycode, basecurrency),
      baseCurrencyId: getAssetId(currencycode, basecurrency).baseCurrencyId,
      currencyId: getAssetId(currencycode, basecurrency).currencyId,
      uuid: localStorage.getItem("uuid"),
    };

    try {
      const response = await axios.post(
        `${WEBSERVICE}userTrade/TradeCreateOffer`,
        JSON.stringify(inputObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      // setLoading(false);
      const result = response.data;
      if (result.error.error_data !== 0) {
        if (result.error.error_data === 2) {
          showErrorDialog(result);
        } else {
          showToast("error", result.error.error_msg);
        }
        setLoading(false);
      } else {
        resetSell();
        showToast("success", result.error.error_msg);
        getUserTransaction();
        setUpdateOrder((prev) => !prev);
        setLoading(false);
        // handleRender();
      }
    } catch (error) {
      setLoading(false);
      console.error("Error executing market sell:", error);
      showToast("error", "An error occurred while processing your request");
    }
  };

  const resetSell = () => {
    setSliderValue(0);
    setOnlySellAmount("");
    setOnlySellPrice("");
    setOnlySellTotalPrice("");
  };

  const checkNumber = (num) => (isNaN(num) ? 0 : num);

  return (
    <div>
      <div className="trade-wrap">
        {/* ── BUY PANEL ── */}
        <div className="trade-panel trade-panel-buy">
          <div className="trade-side-label buy-label">
            Buy {currencycode?.toUpperCase()}
          </div>

          <div className="trade-bal-row">
            <span className="bal-amount">
              {selectedSellingAssetBalance} {basecurrency?.toUpperCase()}
            </span>
            <span className="bal-actions">
              <span
                className="deposit-withdraw-btn"
                style={{ position: "relative" }}
              >
                {basecurrency?.toUpperCase() === "USD" ? (
                  <span className="diposit-hover">DEPOSIT</span>
                ) : (
                  <span className="diposit-hover">RECEIVE</span>
                )}
                <TelegramIcon
                  style={{
                    transform: "rotate(-90deg)",
                    cursor: "pointer",
                    width: 16,
                    height: 16,
                    opacity: 0.55,
                  }}
                  onClick={() => navigate("/my-wallet")}
                />
              </span>
              <InfoIcon
                style={{ fontSize: 14, opacity: 0.45, cursor: "pointer" }}
                onClick={() => setShow(true)}
              />
            </span>
          </div>

          <div className="trade-input-group">
            <label>Amount</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder={minBuySellAmount?.minBuyQty}
                value={onlyBuyAmount}
                onChange={handleChange}
                onKeyUp={handleKeyUp}
              />
              <span className="trade-unit">{currencycode?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Best Market Price</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={checkNumber(onlyBuyPrice)}
                readOnly
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Total</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={checkNumber(onlyBuyTotalPrice)}
                onChange={(e) => handleAmountFromTotalPrice(e, "buy")}
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-pct-row" ref={progressBarRef}>
            {[25, 50, 75, 100].map((pct) => (
              <button
                key={pct}
                className={`trade-pct-btn ${progress === pct ? "pct-active-buy" : ""
                  }`}
                onClick={() => {
                  setProgress(pct);
                  fetchMarketData(pct);
                }}
              >
                {pct}%
              </button>
            ))}
          </div>

          <button
            className="trade-action-btn btn-buy"
            disabled={
              !(onlyBuyAmount > 0) ||
              isLoading ||
              onlyBuyAmount < minBuySellAmount?.minBuyQty
            }
            onClick={marketBuy}
          >
            {isLoading ? "Loading..." : `BUY ${currencycode?.toUpperCase()}`}
          </button>
        </div>

        {/* ── SELL PANEL ── */}
        <div className="trade-panel">
          <div className="trade-side-label sell-label">
            Sell {currencycode?.toUpperCase()}
          </div>

          <div className="trade-bal-row">
            <span className="bal-amount">
              {selectedBuyingAssetBalance} {currencycode?.toUpperCase()}
            </span>
            <span className="bal-actions">
              <span
                className="deposit-withdraw-btn"
                style={{ position: "relative" }}
              >
                {basecurrency?.toUpperCase() === "USD" ? (
                  <span className="diposit-hover">DEPOSIT</span>
                ) : (
                  <span className="diposit-hover">RECEIVE</span>
                )}
                <TelegramIcon
                  style={{
                    transform: "rotate(-90deg)",
                    cursor: "pointer",
                    width: 16,
                    height: 16,
                    opacity: 0.55,
                  }}
                  onClick={() => navigate("/my-wallet")}
                />
              </span>
              <InfoIcon
                style={{ fontSize: 14, opacity: 0.45, cursor: "pointer" }}
                onClick={() => setShow(true)}
              />
            </span>
          </div>

          <div className="trade-input-group">
            <label>Amount</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder={minBuySellAmount?.minSellQty}
                value={onlySellAmount}
                onChange={getSellVal}
              />
              <span className="trade-unit">{currencycode?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Price</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={checkNumber(onlySellPrice)}
                readOnly
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-input-group">
            <label>Total</label>
            <div className="trade-input-box">
              <input
                type="number"
                placeholder="0.00"
                value={checkNumber(onlySellTotalPrice)}
                onChange={(event) => handleAmountFromTotalPrice(event, "sell")}
              />
              <span className="trade-unit">{basecurrency?.toUpperCase()}</span>
            </div>
          </div>

          <div className="trade-pct-row" ref={sliderRef}>
            {[25, 50, 75, 100].map((pct) => (
              <button
                key={pct}
                className={`trade-pct-btn ${sliderValue === pct ? "pct-active-sell" : ""
                  }`}
                onClick={() => {
                  setSliderValue(pct);
                  const calculatedSellAmount =
                    selectedBuyingAssetBalance * (pct / 100);
                  setOnlySellAmount(
                    parseFloat(calculatedSellAmount).toFixed(tradep)
                  );
                  getSellValSlider(calculatedSellAmount);
                  validateMarketSell();
                }}
              >
                {pct}%
              </button>
            ))}
          </div>

          <button
            className="trade-action-btn btn-sell"
            disabled={
              !(onlySellAmount > 0) ||
              loading ||
              onlySellAmount < minBuySellAmount?.minSellQty ||
              marketSellError
            }
            onClick={marketSell}
          >
            {loading ? "Loading..." : `SELL ${currencycode?.toUpperCase()}`}
          </button>
        </div>
      </div>

      <InfoPopUp
        open={show}
        onClose={handleClose}
        title={title}
        description={description}
      />
      <AccreditationVerificationPopup
        open={showAccreditedPopup}
        onClose={() => setShowAccreditedPopup(false)}
        theme={localStorage.getItem("theme")}
      />
      <TermsAgreementPopup
        open={showTermsPopup}
        onClose={() => {
          setShowTermsPopup(false);
          setPendingProceed(null);
        }}
        onProceed={() => {
          if (typeof pendingProceed === "function") {
            pendingProceed();
          }
          setPendingProceed(null);
        }}
        links={termsLinks}
        theme={localStorage.getItem("theme")}
        vestingCurrency={currencycode}
        txnType={pendingTxnType}
      />
    </div>
  );
};

export default BuyAndSellMarket;
